import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLaptopCode,
  faShoppingCart,
  faProjectDiagram,
  faDatabase,
  faMobileAlt,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const services = [
  {
    icon: <FontAwesomeIcon icon={faLaptopCode} size="3x" />,
    text: "Custom Web Development Solutions",
    title: "Web Solution",
    path: "/web-solution",
  },
  {
    icon: <FontAwesomeIcon icon={faShoppingCart} size="3x" />,
    text: "Scalable E-Commerce Development Services",
    title: "E-Commerce Services",
    path: "/e-commerce-services",
  },
  {
    icon: <FontAwesomeIcon icon={faProjectDiagram} size="3x" />,
    text: "CRM, SCM & ERP System Integration",
    title: "CRM SCM and ERP Services",
    path: "/crm-scm-and-erp-services",
  },
  {
    icon: <FontAwesomeIcon icon={faDatabase} size="3x" />,
    text: "Content Management System Development",
    title: "Content Management Service",
    path: "/content-management-system",
  },
  {
    icon: <FontAwesomeIcon icon={faMobileAlt} size="3x" />,
    text: "Mobile App Design & Development",
    title: "Mobile Application Services",
    path: "/mobile-application-services",
  },
  {
    icon: <FontAwesomeIcon icon={faSearch} size="3x" />,
    text: "Search Engine & Social Media Optimization",
    title: "SEO, SMO Services",
    path: "/seo-services",
  },
];

const OurServices = () => {
  return (
    <div className="py-10  px-4 bg-primaryPri h-auto lg:h-[70vh] md:h-[60vh]">
      {/* // <div className=" bg-primaryPri py-10"> */}
      <div>
        <h2 className="text-center  text-main font-semibold text-2xl md:text-3xl leading-tight mb-2 animate-fade-in">
          Highest Quality And Premium Services !
        </h2>
        <h2 className="text-center text-gray-500 font-semibold  capitalize text-md md:text-lg leading-snug mb-4 animate-fade-in">
          we invest our mind resources to develop technology
        </h2>
      </div>

      <div className="flex flex-wrap justify-center gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="flex flex-col items-center group cursor-pointer"
          >
            <div className="relative w-36 h-36 flex items-center justify-center">
              {/* Bottom Circle with Text */}
              <div className="absolute w-36 h-36 bg-main1 rounded-full flex items-center justify-center text-white text-center p-4 text-sm font-semibold z-0 transition-opacity duration-500 opacity-100 group-hover:opacity-100">
                <Link to={service.path}>{service.text}</Link>
              </div>

              {/* Top Circle with Icon */}
              <div className="absolute w-32 text-white h-32 bg-main border border-gray-300 rounded-full flex items-center justify-center z-10 transition-transform duration-500 group-hover:-translate-y-24 shadow-md">
                {service.icon}
              </div>
            </div>

            {/* Label */}
            <p className="mt-4 text-center font-medium text-[#0e2b4a]">
              {service?.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurServices;
